module.exports = __webpack_public_path__ + "img/lookbook_8_left.d87d4784.png";